import { useState } from 'react';
import AlertsModal from './AlertsModal';
import { IDataroomListItem } from '../../../../domain/vo/DataroomListItem';

export default function useAlertsModal() {
  const [dataroom, setDataroom] = useState<IDataroomListItem | null>(null);

  const showAlertsModal = (dataroom: IDataroomListItem) => {
    setDataroom(dataroom);
  };

  const hideAlertsModal = () => {
    setDataroom(null);
  };

  return {
    AlertsModal,
    dataroom,
    showAlertsModal,
    hideAlertsModal,
  };
}
